module.exports = __webpack_public_path__ + "img/vaughn-back-patio.fb7ae510.webp";